<template>
  <v-container color="primary" class="pa-4" style="max-width: 1000px;">

    <!-- Diálogo con v-calendar -->
    <v-dialog v-model="dialogVentana" max-width="1200px" persistent transition="dialog-bottom-transition" scrollable>
      <v-card class="rounded-lg elevation-4 overflow-hidden">
        <v-toolbar flat color="white" class="border-bottom">
          <v-icon color="primary" class="mr-3">event_available</v-icon>
          <v-toolbar-title class="headline font-weight-bold primary--text">
            Seleccionar Horario de Reservación Embarque
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
            v-model="mostrarCancelados"
            label="Mostrar cancelados"
            hide-details
            class="ma-0 pa-0 mr-4 mt-1"
          ></v-switch>
          <v-select
            v-model="horaInicioCalendario"
            :items="horasLista"
            label="Hora inicial"
            dense
            outlined
            hide-details
            class="mr-2"
            style="max-width: 150px"
          ></v-select>
          <v-select
            v-model="horaFinCalendario"
            :items="horasLista"
            label="Hora final"
            dense
            outlined
            hide-details
            class="mr-2"
            style="max-width: 150px"
          ></v-select>
          <v-btn
            color="primary"
            class="ml-2"
            depressed
            @click="abrirModoEdicion"
            :disabled="form.fechaVentana < today"
          >
            Modo Edición
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogVentana = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
            <div class="d-flex align-center">
              <v-btn small depressed color="primary lighten-4" @click="goPrev()" :loading="loadingShippingWindows" class="mr-2">
                <v-icon color="primary">chevron_left</v-icon>
              </v-btn>
              <v-menu
                ref="menuVentana2"
                v-model="menuVentana2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="date-display px-4 py-2 rounded-pill lighten-5 primary--text font-weight-bold pointer d-flex align-center" v-bind="attrs" v-on="on">
                    <v-icon color="primary">calendar_today</v-icon>
                    {{ form.fechaVentana }}
                  </div>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="form.fechaVentana"
                  :locale="$t('region')"
                  @change="saveDate"
                  @input="menuVentana2 = false"
                  color="primary"
                />
              </v-menu>

              <v-btn small depressed color="primary lighten-4" @click="goNext" :loading="loadingShippingWindows" class="ml-2">
                <v-icon color="primary">chevron_right</v-icon>
              </v-btn>
            </div>

            <div class="legend d-flex align-center mt-2 mt-sm-0 flex-wrap">
              <div class="legend-item d-flex align-center mr-4 mb-2">
                <div class="legend-box status-programada mr-2"></div>
                <span class="caption font-weight-medium">Programada</span>
              </div>
              <div class="legend-item d-flex align-center mr-4 mb-2">
                <div class="legend-box status-confirmada mr-2"></div>
                <span class="caption font-weight-medium">Confirmada</span>
              </div>
              <div class="legend-item d-flex align-center mr-4 mb-2">
                <div class="legend-box status-en-sitio mr-2"></div>
                <span class="caption font-weight-medium">En Sitio</span>
              </div>
              <div class="legend-item d-flex align-center mr-4 mb-2">
                <div class="legend-box status-en-proceso mr-2"></div>
                <span class="caption font-weight-medium">En Proceso</span>
              </div>
              <div class="legend-item d-flex align-center mr-4 mb-2">
                <div class="legend-box status-liberada mr-2"></div>
                <span class="caption font-weight-medium">Liberada</span>
              </div>
              <div class="legend-item d-flex align-center mr-4 mb-2">
                <div class="legend-box status-completada mr-2"></div>
                <span class="caption font-weight-medium">Completada</span>
              </div>
              <div class="legend-item d-flex align-center mb-2">
                <div class="legend-box status-cancelada mr-2"></div>
                <span class="caption font-weight-medium">Cancelada</span>
              </div>
            </div>
          </div>

          <div class="calendar-container-wrapper">
            <v-row no-gutters class="calendar-grid">
              <v-col v-for="(item, index) in calendars" :key="index" class="calendar-column border-right border-left">
                <div class="calendar-header-title py-3 text-center primary--text font-weight-bold border-bottom">
                  {{ item.name }}
                </div>
                <v-calendar
                  ref="calendarwe"
                  v-model="currentDate"
                  hide-header
                  :value="today"
                  :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                  type="day"
                  :locale="$t('region')"
                  :interval-minutes="30"
                  :interval-count="intervalCount"
                  :first-interval="firstInterval"
                  :events="item.events"
                  :interval-format="intervalFormat"
                  @click:time="agregarNewEventoToCalendar($event, index, item.id)"
                  class="custom-calendar-style"
                >
                  <template v-slot:interval="{ hour, minute }">
                    <div class="interval-label text-center caption grey--text text--darken-1">
                      {{ (parseInt(hour) % 24).toString().padStart(2, '0') }}:{{ minute.toString().padStart(2, '0') }}
                    </div>
                  </template>
                  <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                    <template v-for="event in eventsMap[index][date]">
                      <v-tooltip bottom :key="event.id + '-' + event.time">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            :class="['my-event', getStatusClass(event), 'with-time']"
                            :style="{
                              top: minutesToPixels((parseTime(event.time) + (event.virtualTopMinutes || 0)) - parseTime(horaInicioCalendario)) + 'px',
                              height: minutesToPixels(event.duration) + 'px'
                            }"
                            @click="open(event)"
                          >
                            <div class="event-content">
                              <v-icon small color="white" class="mr-1">{{ getStatusIcon(event) }}</v-icon>
                              <span class="event-title">{{ event.title }}</span>
                            </div>
                          </div>
                        </template>
                        <span>{{ event.title }} ({{ formatDisplayTime(event.time) }})</span>
                      </v-tooltip>
                    </template>
                  </template>
                </v-calendar>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 grey lighten-5">
          <v-btn text color="primary" @click="dialogShareProgram = true" class="text-none mr-2 font-weight-bold" style="border-radius: 8px;">
            <v-icon left>share</v-icon>
            Compartir Programa
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogVentana = false" class="text-none">
            Cancelar
          </v-btn>
          <v-btn depressed color="primary" class="text-none px-6 rounded-pill" @click="dialogVentana = false" :disabled="!form.hora">
            {{ $t('confirmar_seleccion') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Sharing Program -->
    <v-dialog v-model="dialogShareProgram" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="primary">
          <v-icon left>email</v-icon>
          <v-toolbar-title class="font-weight-bold">Compartir Programa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogShareProgram = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-alert :value="true" type="info" outline icon="info" class="mb-4">
            Ingresa los correos electrónicos para enviar el programa de embarques de la fecha: <b>{{ form.fechaVentana }}</b>.
          </v-alert>
          <v-layout row wrap align-center>
            <v-flex xs10>
              <v-combobox
                v-model="shareEmailInput"
                :search-input.sync="shareEmailSearchText"
                :items="empleados"
                item-text="id_usuario.email"
                item-value="id_usuario.email"
                label="Correo electrónico"
                outlined
                dense
                prepend-icon="email"
                @keyup.enter="addShareEmail"
                @change="addShareEmail"
                :filter="customFilterEmpleados"
              >
                <template v-slot:item="data">
                  {{ data.item.id_usuario.first_name }} {{ data.item.id_usuario.last_name }} - {{ data.item.id_usuario.email }}
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs2 class="pl-2">
              <v-btn icon color="primary" @click="addShareEmail" class="mt-0 mb-3">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-chip
                v-for="(email, index) in shareEmails"
                :key="index"
                close
                @input="removeShareEmail(index)"
                class="mr-2 mb-2"
                color="primary lighten-4"
                text-color="primary"
            >
                {{ email }}
            </v-chip>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-4 bg-light">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogShareProgram = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            depressed
            class="px-6 font-weight-bold"
            style="border-radius: 8px;"
            :loading="loadingShareProgram"
            @click="generateAndShareProgram"
            :disabled="shareEmails.length === 0"
          >
            Enviar
            <v-icon right>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCalendario" max-width="1200px">
      <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
                Calendario por Dia 
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs2 v-for="i in 4" :key="i">
            Hola
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogCalendario = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogClientes" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Capturar Datos del Nuevo Cliente</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>

            <!-- N° de Cliente -->
            <v-text-field
              v-model="client.code"
              label="N° de Cliente"
              type="number"
              :rules="[v => !!v || 'El número es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Nombre del Cliente -->
            <v-text-field
              v-model="client.name"
              label="Nombre del Cliente"
              :rules="[v => !!v || 'El nombre es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Domicilio -->
            <v-text-field
              v-model="client.address"
              label="Domicilio"
              :rules="[v => !!v || 'El domicilio es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Tiempo de carga -->
            <v-text-field
              v-model="client.loading_time_minutes"
              label="Tiempo de carga (min)"
              type="number"
              min="1"
              :rules="[v => !!v || 'El tiempo es requerido']"
              color="primary"
            ></v-text-field>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="dialogClientes = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" flat @click="guardarCliente">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Modo Edición -->
    <v-dialog v-model="dialogModoEdicion" max-width="900px" scrollable>
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat color="primary" dark>
          <v-icon left>edit</v-icon>
          <v-toolbar-title class="font-weight-bold">Modo Edición - {{ formatDate(form.fechaVentana) }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogModoEdicion = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 bg-light">
          <div v-if="loadingEdicion" class="text-center pa-10">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            <div class="mt-4 grey--text text--darken-1">Cargando eventos...</div>
          </div>

          <div v-else>
            <div v-if="Object.keys(groupedEvents).length === 0" class="text-center pa-10 grey--text">
              <v-icon size="64" class="mb-4">calendar_today</v-icon>
              <div>No hay eventos programados para este día.</div>
            </div>

            <v-list v-else three-line class="transparent">
              <template v-for="(group, areaId) in groupedEvents">
                <v-subheader :key="'header-' + areaId" class="primary--text font-weight-bold title mb-2 mt-4">
                  <v-icon left color="primary">forklift</v-icon>
                  {{ group.name }}
                </v-subheader>

                <v-card :key="'card-' + areaId" class="mb-4 rounded-lg elevation-2 overflow-hidden">
                  <v-list class="pa-0">
                    <template v-for="(event, index) in group.events">
                      <v-list-item :key="event.id">
                        <v-list-item-avatar color="primary lighten-5">
                          <v-icon color="primary">{{ getStatusIcon(event) }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ event.client_name || 'Sin Cliente' }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="primary--text font-weight-medium">
                            {{ event.window_time }} - {{ event.title }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            Transporte: {{ event.transport_type_name || 'No especificado' }} | Duración: {{ event.loading_time_minutes }} min
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action class="flex-row">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon small color="primary"
                                v-bind="attrs" v-on="on"
                                :disabled="!['PROGRAMADA', 'CONFIRMADA'].includes(event.title.toUpperCase())"
                                @click="modificarEvento(event)"
                                class="mr-1"
                              >
                                <v-icon small>edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Modificar</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon small color="error"
                                v-bind="attrs" v-on="on"
                                :disabled="!['PROGRAMADA', 'CONFIRMADA'].includes(event.title.toUpperCase())"
                                @click="eliminarEvento(event)"
                              >
                                <v-icon small>block</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancelar</span>
                          </v-tooltip>
                        </v-list-item-action>

                        <v-list-item-action>
                          <v-chip small :class="getStatusClass(event)" text-color="white" class="font-weight-bold">
                            {{ event.title }}
                          </v-chip>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="index < group.events.length - 1" :key="'div-' + event.id"></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </template>
            </v-list>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" class="px-8 rounded-pill font-weight-bold" @click="dialogModoEdicion = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Modificar Horario -->
    <v-dialog v-model="dialogModificarEvento" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat color="primary" dark>
          <v-icon left>edit</v-icon>
          <v-toolbar-title class="font-weight-bold">Modificar Horario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogModificarEvento = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-text-field
            v-model="nuevaHora"
            label="Nueva Hora"
            type="time"
            outlined
            prepend-icon="schedule"
            :error-messages="errores.window_time"
          ></v-text-field>

          <v-textarea
            v-model="motivoModificacion"
            label="Motivo de la modificación"
            outlined
            prepend-icon="description"
            placeholder="Ej. Ajuste por disponibilidad"
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogModificarEvento = false">
            Cancelar
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="px-6 rounded-pill font-weight-bold"
            :loading="loadingModificarEvento"
            @click="confirmarModificacion"
            :disabled="!nuevaHora || !motivoModificacion"
          >
            Modificar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Diálogo Cancelar Evento -->
    <v-dialog v-model="dialogEliminarEvento" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat color="error" dark>
          <v-icon left>block</v-icon>
          <v-toolbar-title class="font-weight-bold">Cancelar Evento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEliminarEvento = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <p class="mb-4">¿Estás seguro de que deseas cancelar este horario para <strong>{{ eventoParaEliminar.client_name || 'Sin Cliente' }}</strong> a las <strong>{{ eventoParaEliminar.window_time }}</strong>?</p>

          <v-textarea
            v-model="motivoCancelacion"
            label="Motivo de la cancelación"
            outlined
            prepend-icon="description"
            placeholder="Ej. Cambio de planes del cliente"
            :error-messages="errores.cancellation_reason"
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogEliminarEvento = false">
            Regresar
          </v-btn>
          <v-btn
            depressed
            color="error"
            class="px-6 rounded-pill font-weight-bold"
            :loading="loadingEliminarEvento"
            @click="confirmarCancelacion"
            :disabled="!motivoCancelacion"
          >
            Confirmar Cancelación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
                {{$t('Invitacion')}}
            </v-toolbar-title>
        </v-toolbar>
      <v-card-text>
        <v-form v-model="valid">
            <v-layout row wrap>
                <!-- <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="domain"
                    label="Empresarial"
                    value="Empresarial"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex>
                <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="anchor"
                    label="Embarque"
                    value="Embarque"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex> -->
                <!-- <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="update"
                    label="Recurrente"
                    value="Recurrente"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex>
                <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="local_activity"
                    label="VIP"
                    value="VIP"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex> -->
            </v-layout>
            <br><br>
          <!-- FILA 1: EMPRESA Y ADMINISTRADOR -->
          <v-layout row wrap>
            <v-flex xs6>
              <!-- Flujo Legacy: Empresa a seleccionar -->
              <v-autocomplete
                v-if="!enableAdvancedShipments"
                v-model="id_empresa_empresarial"
                :items="items"
                prepend-icon="business"
                :loading="isLoading_empresas"
                :search-input.sync="search"
                item-text="name"
                item-value="id"
                box
                :placeholder="$t('placeholder_empresas')"
                :label="$t('Empresa')"
                :error-messages="errores.empresa"
                :no-data-text="$t('no_resultados')"
                @input="get_managerByCompany(id_empresa_empresarial); getEmpresaAdvancedSettings(id_empresa_empresarial)"
                clearable
              >
                <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      class="chip--select-multi"
                    >
                      {{ data.item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }}
                </template>
              </v-autocomplete>

              <!-- Flujo Advanced (Interno y Externo): Transportista - Combobox permitiendo entrada libre -->
              <v-combobox
                v-if="enableAdvancedShipments"
                v-model="selectedCarrier"
                :items="carriers"
                :search-input.sync="carrierSearchText"
                :loading="loadingCarriers"
                item-text="name"
                item-value="id"
                prepend-icon="business"
                box
                placeholder="Selecciona del catálogo o ingresa uno nuevo"
                label="Seleccionar o Ingresar Transportista"
                hint="Selecciona del catálogo o escribe un nombre nuevo"
                :error-messages="errores.empresa"
                @input="onCarrierSelected($event)"
                clearable
                return-object
              >
                <template v-slot:item="data">
                  <div class="d-flex flex-column">
                    <span class="font-weight-bold">{{ data.item.name || data.item.company_name }}</span>
                    <span class="caption grey--text">{{ data.item.email }}</span>
                  </div>
                </template>
                <template v-slot:selection="data">
                  <span v-if="typeof data.item === 'string'">{{ data.item }}</span>
                  <span v-else>{{ data.item.name || data.item.company_name }}</span>
                </template>
              </v-combobox>
            </v-flex>

            <v-flex xs6>
              <!-- Flujo Legacy: Administrador registrado -->
              <v-autocomplete
                v-if="!enableAdvancedShipments"
                v-model="admin"
                prepend-icon="email"
                name="admin"
                box
                return-object
                item-text="first_name"
                item-value="email"
                :label="$t('email_admin')"
                :filter="customFilterAdministradores"
                :error-messages="errores.administrador"
                :items="administradores"
                :no-data-text="$t('no_resultados')"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    class="chip--select-multi"
                  >
                    {{data.item.email}}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  {{data.item.first_name}} {{ data.item.last_name}} - {{data.item.email}}
                </template>
              </v-autocomplete>

              <!-- Flujo Advanced (Interno y Externo): Email del Administrador a Invitar -->
              <v-text-field
                v-if="enableAdvancedShipments"
                v-model="adminEmailInvitacion"
                prepend-icon="email"
                label="Email del Administrador de Transportista"
                type="email"
                box
                placeholder="admin@transportista.com"
                :error-messages="errores.administrador"
                :hint="selectedCarrier && selectedCarrier.id ? 'Precargado del catálogo' : 'Ingrese el email del administrador/contacto'"
              ></v-text-field>
            </v-flex>

            <v-alert
              v-if="bandSinAdministrador === true && !enableAdvancedShipments"
              :value="true"
              type="error"
              outline
              transition="scale-transition"
            >
              {{$t('msg_no_manager_found')}}
            </v-alert>
          </v-layout>

          <!-- FILA 1.5: TIPO DE MOVIMIENTO (EMBARQUE O RECEPCION) - Solo si enable_advanced_shipments -->
          <v-layout row wrap v-if="enableAdvancedShipments" class="mb-3">
            <v-flex xs12>
              <div class="subheading mb-2 primary--text font-weight-bold">Tipo de Movimiento</div>
              <v-radio-group v-model="tipoMovimiento" row>
                <v-radio
                  label="Embarque (Salida)"
                  value="EMBARQUE"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="Recepción (Entrada)"
                  value="RECEPCION"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>

          <!-- FILA 1.6: TIPO DE ASIGNACION (INTERNA O EXTERNA) - Solo si enable_advanced_shipments -->
          <v-layout row wrap v-if="enableAdvancedShipments" class="mb-3">
            <v-flex xs12>
              <div class="subheading mb-2 primary--text font-weight-bold">Tipo de Asignación</div>
              <v-radio-group v-model="isInternal" row>
                <v-radio
                  label="Asignación Interna (Chofer Propio)"
                  :value="true"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="Asignación Externa (Tercero)"
                  :value="false"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>

          <!-- FILA 2: AREA DE CARGA Y FECHA -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                v-if="tipoMovimiento !== 'RECEPCION'"
                v-model="form.client_ids"
                :items="clients"
                item-text="name"
                item-value="id"
                :error-messages="errores.client_ids || errores.client"
                :rules="[v => (v && v.length > 0) || 'Debes seleccionar al menos una planta destino']"
                label="Plantas Destino"
                chips
                multiple
                outlined
                prepend-icon="corporate_fare"
                placeholder="Buscar y seleccionar plantas"
                @input="rellenaCamposDireccionDuracionCarga()"
                clearable
              />
              <v-text-field
                v-else
                :value="destinationCompanyName"
                :error-messages="errores.destination_company_name"
                label="Planta destino"
                outlined
                disabled
                prepend-icon="corporate_fare"
              />
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <v-btn
                color="primary"
                :disabled="!puedeVerDisponibilidad"
                :loading="loadingShippingWindows"
                @click="fillRandomCalendars()"
              >
                Ver disponibilidad de áreas de carga&nbsp;<v-icon>forklift</v-icon>
              </v-btn>
              <v-menu
                ref="menuVentana"
                v-model="menuVentana"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaVentana"
                    :label="$t('fecha_inv')"
                    prepend-icon="today"
                    readonly
                    :error-messages="errores.window_date"
                    disabled
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="form.fechaVentana"
                  @input="menuVentana = false"
                />
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- FILA 2.1: Días de la Semana Y Fecha Final -->
          <v-layout row wrap v-show="form.opciones.includes('Recurrente')">
            <v-flex xs6>              
              <div v-if="form.opciones.includes('Recurrente')" class="subheading mb-2">Selecciona los días</div>
              <v-layout row wrap v-if="form.opciones.includes('Recurrente')">
                <v-flex v-for="dia in diasSemana" :key="dia" xs6>
                  <v-checkbox
                    v-model="form.dias"
                    :label="dia"
                    :value="dia"
                    hide-details
                    dense
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-menu
              v-if="form.opciones.includes('Recurrente')"
                ref="menuVentanaRecurrente"
                v-model="menuVentanaRecurrente"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaVentanaRecurrente"
                    label="Fecha Final"
                    prepend-icon="today"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="form.fechaVentanaRecurrente" @input="menuVentanaRecurrente = false" />
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- FILA 3: Planta Destino Y Hora -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                v-model="form.areas"
                :items="chargeAreas"
                disabled
                item-text="name"
                item-value="id"
                :label="$t('landing_area')"
                chips
                outlined
                prepend-icon="grid_view"
                placeholder="Buscar por ID"
                readonly
              />
            </v-flex>
            <!-- <v-flex xs1>
                <v-btn
                    icon
                    color="primary"
                    class="mt-4"
                    @click="abrirDialogClientes"
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs1>
                <v-btn
                    icon
                    color="primary"
                    class="mt-4"
                    @click="llenarDialogClientes"
                >
                    <v-icon>edit</v-icon>
                </v-btn>
            </v-flex> -->
            <v-flex xs6>
              <v-text-field
                outlined
                disabled
                prepend-icon="schedule"
                v-model="form.hora"
                :error-messages="errores.window_time"
                :label="$t('hora_inv')"
                type="time"
              />
            </v-flex>
          </v-layout>

          <!-- FILA 3.5: CHOFER Y VEHICULO - Solo si enable_advanced_shipments e isInternal -->
          <v-layout row wrap v-if="enableAdvancedShipments && isInternal" class="mb-3">
            <v-flex xs6>
              <v-autocomplete
                v-model="empleadoId"
                :items="availableDrivers"
                item-text="id_usuario_name"
                item-value="id"
                :label="`${tipoMovimiento === 'RECEPCION' ? 'Seleccionar Receptor' : 'Seleccionar Chofer'} (${availableDrivers.length} disponibles)`"
                outlined
                prepend-icon="person"
                clearable
                placeholder="Buscar por nombre"
                :loading="loadingAvailableDrivers"
                :disabled="!form.fechaVentana || !form.hora"
                hint="Selecciona fecha y hora primero para ver disponibles"
              />
            </v-flex>
            <v-flex xs6 v-if="tipoMovimiento === 'EMBARQUE'">
              <v-autocomplete
                v-model="vehicleId"
                :items="vehicles"
                item-text="license_plate"
                item-value="id"
                label="Seleccionar Vehículo"
                outlined
                prepend-icon="directions_car"
                clearable
                placeholder="Buscar por placa"
              />
            </v-flex>
          </v-layout>

          <!-- FILA 4: Domicilio/Duracion de la Carga Y Tipo de Transporte -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-textarea
                v-model="form.address"
                :label="$t('client_address')"
              />
              <v-text-field
                v-model="form.loading_time_minutes"
                :label="$t('loading_time') + ' (min)'"
                type="number"
              />
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                v-model="form.typeTransport"
                :items="typesOfTransports"
                item-text="name"
                item-value="id"
                :error-messages="errores.transport_type"
                :label="$t('type_transport')"
                chips
                outlined
                prepend-icon="unarchive"
                placeholder="Buscar por ID"
                clearable
              />
            </v-flex>
          </v-layout>

          <!-- FILA 5: DÍAS Y NOTAS -->
          <v-layout row wrap>
            <!-- <v-flex xs6>
            <div class="mb-2 font-weight-medium">Ventanas Fijas</div>
                <v-row dense>
                    <v-col>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.fecha"
                                label="Fecha"
                                prepend-icon="today"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                            />
                            </template>
                            <v-date-picker v-model="form.fecha" @input="menu = false" />
                        </v-menu>
                        <v-text-field
                            outlined
                            v-model="form.hora"
                            label="Hora"
                            type="time"
                            prepend-icon="schedule"
                        />
                    </v-col>
                </v-row>
            </v-flex> -->
            <v-flex xs6>
              <v-textarea
                v-model="form.notas"
                :label="$t('Notas')"
                :error-messages="errores.observations"
                :placeholder="$t('placeholder_notas')"
              />
            </v-flex>
            <v-flex xs12 sm6 v-show="documentationsByCompany.length > 0">
                <div class="subheading mb-2">Documentos adicionales</div>
                <div class="text mb-2">* Documentos requeridos para validación</div>
                <v-layout row wrap>
                    <v-flex v-for="doc in documentationsByCompany" :key="doc.idDocumentation" xs6>
                    <v-checkbox
                        v-model="documentos"
                        :label="doc.name"
                        :value="doc.idDocumentation"
                        hide-details
                        dense
                    ></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex>
          </v-layout>

          <!-- BOTONES -->
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <!-- <v-btn color="primary" @click="generarPDF" :disabled="!valid" class="mr-2">
                Generar PDF
              </v-btn> -->
              <v-btn color="primary" @click="enviarInvitacion" :loading="loadingInvitacion">
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
import JSPDF from 'jspdf'
import 'jspdf-autotable'
import '@/plugins/axios'
import store from '@/store'
import {mapGetters, mapState} from 'vuex'
import { USER_REQUEST } from '@/store/actions/user'

export default {
  data: () => ({
    valid: true,
    documentos: [],
    menu: false,
    today: new Date().getFullYear() + "-" + String(new Date().getMonth() + 1).padStart(2, '0') + "-" + String(new Date().getDate()).padStart(2, '0'), // '2025-03-31',
    menuVentana: false,
    menuVentana2: false,
    menuVentanaRecurrente: false,
    dialogClientes: false,
    dialogVentana: false,
    dialogCalendario: false,
    eventos: [
        {        
            title: 'COMPLETADA',
            date: '2025-06-23',
            time: '01:30',
            duration: 30,
        },
        {        
            title: 'EN PROCESO',
            date: '2025-06-23',
            time: '02:00',
            duration: 60,
        },
        {
            title: 'CONFIRMADA',
            date: '2025-06-23',
            time: '03:30',
            duration: 30,
        }
    ],
    selected: new Date().getFullYear() + "-" + String(new Date().getMonth() + 1).padStart(2, '0') + "-" + String(new Date().getDate()).padStart(2, '0'), 
    diasSemana: [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo'
    ],
    form: {
      opciones: [],
      fecha: '',
      fechaVentana: '',
      fechaVentanaRecurrente: '',
      hora: '',
      dias: [],
      documentos: [],
      personas: [],
      areas: null,
      client_ids: [],
      address: '',
      loading_time_minutes: '',
      typeTransport: '',
      notas: '',
      empresa: '',
      administrador: ''
    },
    chargeAreas: [],
    clients: [],
    client: {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
    },
    typesOfTransports: [],
    empresas: [
      { id: 1, nombre: 'Transportes y Logística S.A.' },
      { id: 2, nombre: 'Logística Integral S.A. de C.V.' },
      { id: 3, nombre: 'Transporte Express S.A.' },
      { id: 4, nombre: 'Servicios de Carga Rápida S.A.' },
      { id: 5, nombre: 'Logística Avanzada S.A. de C.V.' }
    ],
    administradores: [],
    timeInterval: 10,
    numberSlots: 48,
    disabledCalendar: true,
    disabledCalendar2: true,
    disabledCalendar3: true,
    disabledCalendar4: true,
    disabledCalendar5: true,
    disabledCalendar6: true,
    calendars: [],
    id_empresa: '',
    currentDate: null,
    loadingShippingWindows: false,
    id_empresa_empresarial: '',
    admin: {},
    isLoading_empresas: false,
    bandSinAdministrador: false,
    entries2: [],
    search: null,
    errores: {},
    loadingInvitacion: false,
    bandDeleteEvent: false,
    documentationsByCompany: [],
    dialogShareProgram: false,
    shareEmails: [],
    shareEmailInput: '',
    shareEmailSearchText: '',
    empleados: [],
    loadingShareProgram: false,
    horaInicioCalendario: '00:00',
    horaFinCalendario: '23:00',
    isInitializing: false,
    modoEdicion: false,
    dialogModoEdicion: false,
    loadingEdicion: false,
    groupedEvents: {},
    dialogModificarEvento: false,
    eventoParaModificar: {},
    nuevaHora: '',
    motivoModificacion: '',
    loadingModificarEvento: false,
    dialogEliminarEvento: false,
    eventoParaEliminar: {},
    motivoCancelacion: '',
    loadingEliminarEvento: false,
    mostrarCancelados: true,
    enableAdvancedShipments: false,
    tipoMovimiento: 'EMBARQUE',
    loadingEmpresaData: false,
    isInternal: false,
    empleadoId: '',
    vehicleId: '',
    vehicles: [],
    availableDrivers: [],
    loadingAvailableDrivers: false,
    estimatedDurationHours: 2,
    adminEmailInvitacion: '',
    empresaInvitarNombre: '',
    carriers: [],
    loadingCarriers: false,
    selectedCarrier: null,
    carrierSearchText: '',
  }),
  created: function(){
    this.getDocumentationByCompany()
    this.get_extra_data()
    this.get_empleados()
    const date = new Date()
    this.currentDate = date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0')

    this.form.fechaVentana = this.currentDate

    if (this.getProfile && this.getProfile.shipments_time_window) {
      const times = this.getProfile.shipments_time_window.split('-')
      if (times.length === 2) {
        this.isInitializing = true
        this.horaInicioCalendario = times[0]
        this.horaFinCalendario = times[1]
        this.$nextTick(() => { this.isInitializing = false })
      }
    }
    if (this.getProfile && typeof this.getProfile.enable_advanced_shipments !== 'undefined') {
      this.enableAdvancedShipments = this.getProfile.enable_advanced_shipments
      if (this.enableAdvancedShipments) {
        this.getCarriersCatalog()
      }
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    fields () {
      if (!this.id_empresa_empresarial) return []
      return Object.keys(this.id_empresa_empresarial).map(key => {
        return {
          key,
          value: this.id_empresa_empresarial[key] || 'n/a'
        }
      })
      console.log('Se activo....')
      },
      items () {
        return this.entries2.map(entry => {
          const name = entry.name.length > this.descriptionLimit
              ? entry.name.slice(0, this.descriptionLimit) + '...'
              : entry.name

          return Object.assign({}, entry, { name })
        })          
      },
      eventsMap () {
        let algo = []
        const [sH, sM] = (this.horaInicioCalendario || '00:00').split(':').map(Number)
        const [eH, eM] = (this.horaFinCalendario || '23:00').split(':').map(Number)
        const startMin = sH * 60 + sM
        const endMin = eH * 60 + eM
        const isOvernight = startMin > endMin

        for (let i = 0; i < this.calendars.length; i++) {
          const map = {}
          const tempMap = {}

          // Filtrar eventos si mostrarCancelados es false
          const sourceEvents = this.mostrarCancelados
            ? this.calendars[i].events
            : this.calendars[i].events.filter(e => {
                const title = (e.title || '').toUpperCase();
                return title !== 'CANCELADA';
              });

          sourceEvents.forEach(e => (tempMap[e.date] = tempMap[e.date] || []).push(e))

          Object.keys(tempMap).forEach(date => {
            let columnEvents = tempMap[date].filter(e => {
              const [h, m] = e.time.split(':').map(Number)
              return (h * 60 + m) >= startMin
            }).map(e => ({ ...e, virtualTopMinutes: 0 }))

            if (isOvernight) {
              const tomorrow = this.getNextDay(date)
              if (tempMap[tomorrow]) {
                const tomorrowEvents = tempMap[tomorrow].filter(e => {
                  const [h, m] = e.time.split(':').map(Number)
                  return (h * 60 + m) <= endMin
                }).map(e => ({ ...e, virtualTopMinutes: 1440 }))
                columnEvents = columnEvents.concat(tomorrowEvents)
              }
            }
            map[date] = columnEvents
          })
          algo.push(map)
        }
        return algo
      },
      firstInterval () {
        if (!this.horaInicioCalendario) return 0
        const [hours, minutes] = this.horaInicioCalendario.split(':').map(Number)
        return Math.floor((hours * 60 + minutes) / 30)
      },
      intervalCount () {
        if (!this.horaInicioCalendario || !this.horaFinCalendario) return 48
        const [sH, sM] = this.horaInicioCalendario.split(':').map(Number)
        const [eH, eM] = this.horaFinCalendario.split(':').map(Number)
        const startTotal = sH * 60 + sM
        let endTotal = eH * 60 + eM
        if (endTotal <= startTotal) {
          endTotal += 24 * 60
        }
        return Math.floor((endTotal - startTotal) / 30) + 1
      },
      horasLista () {
        const hours = []
        for (let i = 0; i < 24; i++) {
          hours.push(`${i.toString().padStart(2, '0')}:00`)
        }
        return hours
      },
      puedeVerDisponibilidad () {
        if (this.tipoMovimiento === 'RECEPCION') {
          return !!(this.destinationCompanyName && this.destinationCompanyName.trim() !== '')
        }
        return this.form.address !== ''
      },
      destinationCompanyName () {
        return (this.getProfile && this.getProfile.name_company) || ''
      }
  },
  watch: {
      isUpdating (val) {
        if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
        }
      },
      search (val) {
        console.log(val)
        if (val !== null && val !== undefined) {
          if (val.length > 2) {
            this.isLoading_empresas = true
            const config = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/empresas/filter?search=' + val,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            };
            axios(config)
              .then(response => {
                console.log(response.data)
                if (this.entries2.length > 0) {
                  for (var i = 0; i < response.data.length; i++) {
                    this.entries2.push(response.data[i])
                  }
                } else
                  this.entries2 = response.data
              })
              .catch(error => {
                console.log(error)
              })
              .finally(() => (this.isLoading_empresas = false))
          }
        }
      },
      horaInicioCalendario (val) {
        if (val && !this.isInitializing) this.saveShipmentTimeWindow()
      },
      horaFinCalendario (val) {
        if (val && !this.isInitializing) this.saveShipmentTimeWindow()
      },
      getProfile: {
        handler(val) {
          if (val && val.shipments_time_window) {
            const times = val.shipments_time_window.split('-')
            if (times.length === 2) {
              if (this.horaInicioCalendario !== times[0] || this.horaFinCalendario !== times[1]) {
                this.isInitializing = true
                this.horaInicioCalendario = times[0]
                this.horaFinCalendario = times[1]
                this.$nextTick(() => { this.isInitializing = false })
              }
            }
          }
          if (val && typeof val.enable_advanced_shipments !== 'undefined') {
            this.enableAdvancedShipments = val.enable_advanced_shipments
          }
        },
        deep: true
      },
      isInternal(val) {
        if (val && this.form.fechaVentana && this.form.hora) {
          this.getAvailableVehicles()
        } else {
          this.vehicles = []
          this.vehicleId = ''
        }
      },
      tipoMovimiento(val) {
        if (val !== 'EMBARQUE') {
          this.selectedCarrier = null
          this.empresaInvitarNombre = ''
          this.adminEmailInvitacion = ''
          this.isInternal = false
        }
        if (val === 'RECEPCION') {
          this.rellenaCamposRecepcion()
        }
        if (this.enableAdvancedShipments) {
          this.calendars = []
          this.getChargeAreas()
        }
      },
  },
  methods: {
    getDocumentationByCompany: function(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
        .then(response => {
            this.documentationsByCompany = response.data
        })
        .catch(error => {
            console.log(error)
        })
    },
    getEmpresaAdvancedSettings: function(empresaId) {
      if (!empresaId) {
        this.vehicleId = ''
        this.vehicles = []
        return
      }

      this.loadingEmpresaData = false
    },
    getAvailableDrivers: function() {
      if (!this.form.fechaVentana || !this.form.hora || !this.getProfile || !this.getProfile.id_company) {
        this.availableDrivers = []
        return
      }

      this.loadingAvailableDrivers = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/availability/drivers/list/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          company_id: this.getProfile.id_company,
          window_date: this.form.fechaVentana,
          window_time: this.form.hora,
          estimated_duration_hours: this.estimatedDurationHours
        }
      }

      axios(config)
        .then(response => {
          this.availableDrivers = response.data.drivers || []
          this.empleadoId = ''
          console.log('Choferes disponibles:', this.availableDrivers)
        })
        .catch(error => {
          console.log('Error obteniendo choferes disponibles:', error)
          this.availableDrivers = []
        })
        .finally(() => {
          this.loadingAvailableDrivers = false
        })
    },
    getAvailableVehicles: function() {
      if (!this.form.fechaVentana || !this.form.hora || !this.getProfile || !this.getProfile.id_company || !this.isInternal || this.tipoMovimiento !== 'EMBARQUE') {
        this.vehicles = []
        return
      }

      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/availability/vehicles/list/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          company_id: this.getProfile.id_company,
          window_date: this.form.fechaVentana,
          window_time: this.form.hora
        }
      }

      axios(config)
        .then(response => {
          this.vehicles = response.data.vehicles || []
          this.vehicleId = ''
        })
        .catch(error => {
          console.log('Error obteniendo vehículos disponibles:', error)
          this.vehicles = []
        })
    },
    getCarriersCatalog: function() {
      this.loadingCarriers = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/advanced/carriers/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      axios(config)
        .then(response => {
          this.carriers = response.data || []
          console.log('Catálogo de transportistas cargado:', this.carriers)
        })
        .catch(error => {
          console.log('Error obteniendo catálogo de transportistas:', error)
          this.carriers = []
        })
        .finally(() => {
          this.loadingCarriers = false
        })
    },
    onCarrierSelected: function(carrier) {
      if (carrier && typeof carrier === 'object' && carrier.id) {
        this.adminEmailInvitacion = carrier.email || ''
      } else {
        this.adminEmailInvitacion = ''
      }
    },
    get_empleados: function() {
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/empresas/empleados/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            }
        };
        axios(config)
            .then(response => {
                this.empleados = response.data;
            })
            .catch(error => {
                console.log(error);
            });
    },
    customFilterEmpleados(item, queryText, itemText) {
        const firstName = (item.id_usuario && item.id_usuario.first_name) ? item.id_usuario.first_name.toLowerCase() : '';
        const lastName = (item.id_usuario && item.id_usuario.last_name) ? item.id_usuario.last_name.toLowerCase() : '';
        const email = (item.id_usuario && item.id_usuario.email) ? item.id_usuario.email.toLowerCase() : '';
        const searchText = queryText.toLowerCase();

        return firstName.indexOf(searchText) > -1 ||
               lastName.indexOf(searchText) > -1 ||
               email.indexOf(searchText) > -1;
    },
    customFilterAdministradores (item, queryText) {
      const textOne = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    get_name_company(){
      // console.log('VALOR DE CAMPO = ', this.id_empresa_empresarial)
      for(var i = 0 ; i < this.entries2.length ; i++){
        if(this.entries2[i].id === this.id_empresa_empresarial) {
          // console.log('NAME COMPANY = ', this.entries2[i].name)
          return this.entries2[i].name
        }
      }
    },
    get_managerByCompany: function(id_company){
        console.log(id_company)
        if (id_company !== null && id_company !== undefined) {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/administradoresByCompany/' + id_company,
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    if (response.data.length === 0) {
                        this.admin = {}
                        this.bandSinAdministrador = true
                    } else {
                        this.bandSinAdministrador = false
                    }
                    this.administradores = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            this.admin = {}
            this.administradores = []
            this.bandSinAdministrador = false
        }
    },
    fillRandomCalendars () {
      this.calendars.forEach(c => {
        c.events = c.events.filter(e => e.title === 'Seleccionado')
      })
      this.bandDeleteEvent = true
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: this.currentDate,
            end_date: this.currentDate,
            empresa: this.id_empresa
          }
      };
      axios(config)
          .then(response => {
              if (this.calendars.length > 0) {
              for (let i = 0; i < this.calendars.length; i ++) {
                this.calendars[i].events = this.calendars[i].events.filter(e => e.title === 'Seleccionado')
                for (let j = 0; j < response.data.length; j++) {
                  if(response.data[j].loading_area === this.calendars[i].id) {
                    const statuses = ['PROGRAMADA', 'CONFIRMADA', 'EN SITIO', 'EN PROCESO', 'LIBERADA', 'COMPLETADA', 'CANCELADA'];
                    const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
                    this.calendars[i].events.push(
                      {
                        ...response.data[j],
                        title: response.data[j].status || randomStatus,
                        date: response.data[j].window_date,
                        time: response.data[j].window_time,
                        duration: response.data[j].loading_time_minutes,
                        id: response.data[j].id,
                        new: false
                      }
                    )
                  }
                }
              }
            }
            this.loadingShippingWindows = false
            this.dialogVentana = true
          })
          .catch(error => {
              console.log(error)
              this.loadingShippingWindows = false
          })
    },
    abrirModoEdicion() {
      this.dialogModoEdicion = true;
      this.loadingEdicion = true;
      this.groupedEvents = {};

      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: this.currentDate,
            end_date: this.currentDate,
            empresa: this.id_empresa
          }
      };

      axios(config)
        .then(response => {
          const events = response.data.map(e => ({
            ...e,
            title: e.status || 'PROGRAMADA'
          }));
          // Sort by date and time
          events.sort((a, b) => {
            const dateA = a.window_date + ' ' + a.window_time;
            const dateB = b.window_date + ' ' + b.window_time;
            return dateA.localeCompare(dateB);
          });
          const groupedData = {};
          // Use current chargeAreas to ensure all areas are represented
          this.chargeAreas.forEach(area => {
            const areaEvents = events.filter(e => e.loading_area === area.id);
            if (areaEvents.length > 0) {
              groupedData[area.id] = {
                name: area.name,
                events: areaEvents
              };
            }
          });

          this.groupedEvents = groupedData;
          this.loadingEdicion = false;
        })
        .catch(error => {
          console.error(error);
          this.loadingEdicion = false;
          this.$store.commit('snackbar_change_color', 'error');
          this.$store.commit('snackbar_activate_true');
          this.$store.commit('snackbar_change_message', 'Error al obtener los eventos del día');
        });
    },
    modificarEvento(event) {
      this.eventoParaModificar = event;
      this.nuevaHora = event.window_time;
      this.motivoModificacion = '';
      this.errores = {};
      this.dialogModificarEvento = true;
    },
    confirmarModificacion() {
      // Validar que la hora sea diferente (comparando HH:mm para evitar problemas con segundos del backend)
      const h1 = (this.nuevaHora || '').split(':').slice(0, 2).join(':');
      const h2 = (this.eventoParaModificar.window_time || '').split(':').slice(0, 2).join(':');

      if (h1 === h2) {
        this.errores = { ...this.errores, window_time: ['La nueva hora debe ser diferente a la hora actual'] };
        return;
      }

      this.loadingModificarEvento = true;
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/update-window-datetime/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          shipping_window_id: this.eventoParaModificar.id,
          window_time: this.nuevaHora,
          reason: this.motivoModificacion
        }
      };

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_change_color', 'success');
          this.$store.commit('snackbar_activate_true');
          this.$store.commit('snackbar_change_message', 'Horario actualizado correctamente');
          setTimeout(this.clear2, 3000);
          this.dialogModificarEvento = false;
          // Actualizar la lista
          this.abrirModoEdicion();
          this.fillCalendars(this.currentDate, this.currentDate);
        })
        .catch(error => {
          console.error(error);
          this.errores = error.response.data;
          this.$store.commit('snackbar_change_color', 'error');
          this.$store.commit('snackbar_activate_true');
          this.$store.commit('snackbar_change_message', 'Error al actualizar el horario');
          setTimeout(this.clear2, 3000);
        })
        .finally(() => {
          this.loadingModificarEvento = false;
        });
    },
    eliminarEvento(event) {
        this.eventoParaEliminar = event;
        this.motivoCancelacion = '';
        this.errores = {};
        this.dialogEliminarEvento = true;
    },
    confirmarCancelacion() {
        this.loadingEliminarEvento = true;
        const config = {
            method: 'post',
            url: 'https://empresa-service.intrare.app/shipments/cancel-window/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data: {
                shipping_window_id: this.eventoParaEliminar.id,
                cancellation_reason: this.motivoCancelacion
            }
        };
        axios(config)
            .then(ok => {
                this.$store.commit('snackbar_change_color', 'success');
                this.$store.commit('snackbar_activate_true');
                this.$store.commit('snackbar_change_message', 'Evento cancelado correctamente');
                setTimeout(this.clear2, 3000);
                this.dialogEliminarEvento = false;
                // Actualizar la lista
                this.abrirModoEdicion();
                this.fillCalendars(this.currentDate, this.currentDate);
            })
            .catch(error => {
                console.error(error);
                this.errores = error.response ? error.response.data : {};
                this.$store.commit('snackbar_change_color', 'error');
                this.$store.commit('snackbar_activate_true');
                setTimeout(this.clear2, 3000);
                this.$store.commit('snackbar_change_message', 'Error al cancelar el evento');
            })
            .finally(() => {
                this.loadingEliminarEvento = false;
            });
    },
    fillCalendars (start_date, end_date) {
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: start_date,
            end_date: end_date,
            empresa: this.id_empresa
          }
      };
      axios(config)
          .then(response => {
              if (this.calendars.length > 0) {
              for (let i= 0; i< this.calendars.length ;i ++)
                this.calendars[i].events = []  
              for (let i = 0; i < this.calendars.length; i ++) {
                for (let j = 0; j < response.data.length; j++) {
                  if(response.data[j].loading_area === this.calendars[i].id) {
                    const statuses = ['PROGRAMADA', 'CONFIRMADA', 'EN SITIO', 'EN PROCESO', 'LIBERADA', 'COMPLETADA', 'CANCELADA'];
                    const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
                    this.calendars[i].events.push(
                      {
                        ...response.data[j],
                        title: response.data[j].status || randomStatus,
                        date: response.data[j].window_date,
                        time: response.data[j].window_time,
                        duration: response.data[j].loading_time_minutes,
                        id: response.data[j].id,
                        new: false
                      }
                    )
                  }
                }
              }
            }
            this.loadingShippingWindows = false
          })
          .catch(error => {
              console.log(error)
              this.loadingShippingWindows = false
          })
    },
    saveDate (date) {
      this.currentDate = date
      this.fillCalendars(this.currentDate, this.currentDate)
      this.form.fechaVentana = date
    },
    goNext() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() + 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      console.log('Fecha == ', this.currentDate)
    },
    goPrev() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() - 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      console.log('Fecha == ', this.currentDate)
    },
    get_extra_data (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/auth/me',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          }
      };
      axios(config)
          .then(response => {
            this.id_empresa = response.data.id_company

            this.getChargeAreas()
            this.getClients()
            this.getTypesOfTransports()
          })
          .catch(error => {
              console.log(error)
          })
    },
    createVCalendars (datos) {
      for (let i = 0; i < datos.length; i++){
        this.calendars.push(
          {
            id: datos[i].id,
            name: datos[i].name,
            focus: "",
            events: []
          }
        )
      }
    },
    getChargeAreas (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/charge-areas/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
              IdEmpresa: this.id_empresa,
              is_active: true
          }
      };
      axios(config)
          .then(response => {
              this.chargeAreas = response.data
              let areasToDisplay = response.data

              if (this.enableAdvancedShipments && this.tipoMovimiento) {
                areasToDisplay = response.data.filter(area => {
                  if (!area.operation_type) return true
                  if (this.tipoMovimiento === 'EMBARQUE') {
                    return area.operation_type === 'EMBARQUE' || area.operation_type === 'AMBOS'
                  } else if (this.tipoMovimiento === 'RECEPCION') {
                    return area.operation_type === 'RECEPCION' || area.operation_type === 'AMBOS'
                  }
                  return true
                })
              }

              this.createVCalendars(areasToDisplay)
          })
          .catch(error => {
              console.log(error)
          })
    },
    getClients () {
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/clients/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            params: {
                empresa: this.id_empresa,
                is_active: true
            }
        };
        axios(config)
            .then(response => {
                this.clients = response.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    getTypesOfTransports (){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/carrier-types/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          IdEmpresa: this.id_empresa,
          is_active: true
        }
      };
      axios(config)
      .then(response => {
          this.typesOfTransports = response.data
      })
      .catch(error => {
          console.log(error)
      })
    },
    abrirDialogClientes() {
      this.dialogClientes = true
      this.$refs.form.resetValidation()
      this.limpiarFormulario()
    },
    llenarDialogClientes() {
      this.dialogClientes = true
      this.client = {
        code: this.clients[0].code,
        name: this.clients[0].name,
        address: this.clients[0].address,
        loading_time_minutes: this.clients[0].loading_time_minutes
      }
    },
    guardarCliente() {
      if (this.$refs.form.validate()) {
        console.log('Datos del cliente:', this.client)
        alert('Cliente guardado correctamente')
        this.dialogClientes = false
        this.limpiarFormulario()
      }
    },
    limpiarFormulario() {
      this.client = {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
      }
      this.valid = false
    },
    agregarNewEventoToCalendar({ date, time }, index, id) {
      console.log('Calendario con indice = ', index)
      console.log('Fecha seleccionada:', date)
      console.log('Hora seleccionada:', time)

      let [h, m] = time.split(':').map(Number)
      const startMinRaw = this.parseTime(this.horaInicioCalendario)
      const startH = Math.floor(startMinRaw / 60)

      let actualDate = date
      let isNextDay = false

      // Si la hora es >= 24 o si es menor a la hora de inicio en un rango nocturno, es el día siguiente
      if (h >= 24 || (h < startH && this.intervalCount > 12)) {
        actualDate = this.getNextDay(date)
        isNextDay = true
        h = h % 24
      }

      // Truncar a bloques de 30 min y formatear como HH:mm válido para el input type="time"
      const timeAux = `${h.toString().padStart(2, '0')}:${m < 30 ? '00' : '30'}`

      console.log('Hora truncada (HH:mm):', timeAux)
      console.log('Fecha real ajustada:', actualDate)

      const nuevoEvento = {
        title: 'Seleccionado',
        date: actualDate,
        time: timeAux,
        duration: this.form.loading_time_minutes,
        color: 'grey',
        id: id,
        new: true,
        virtualTopMinutes: isNextDay ? 1440 : 0
      }

      // Buscar si ya existe un selección previa (new)
      let oldEvent = null
      let oldCalendarIndex = -1
      for (let i = 0; i < this.calendars.length; i++) {
        const found = this.calendars[i].events.find(e => e.new)
        if (found) {
          oldEvent = found
          oldCalendarIndex = i
          break
        }
      }

      const applySelection = (calIdx, event) => {
        this.calendars[calIdx].events.push(event)
        this.form.hora = event.time
        this.form.fechaVentana = event.date
        this.form.areas = event.id
        this.getAvailableDrivers()
        if (this.isInternal) {
          this.getAvailableVehicles()
        }
      }

      if (!oldEvent) {
        // No hay selección anterior
        applySelection(index, nuevoEvento)
      } else {
        if (this.bandDeleteEvent) {
          // Si ya existe, verificamos si es el mismo lugar para toggle-off
          const isSameSpot = oldEvent.date === nuevoEvento.date &&
                            oldEvent.time === nuevoEvento.time &&
                            this.calendars[oldCalendarIndex].id === id

          // Limpiar selecciones anteriores de todos los calendarios
          for (let i = 0; i < this.calendars.length; i++) {
            this.calendars[i].events = this.calendars[i].events.filter(e => !e.new)
          }

          if (!isSameSpot) {
            // Si el click fue en un lugar distinto, movemos la selección
            applySelection(index, nuevoEvento)
          } else {
            // Si es el mismo lugar, dejamos vacío
            this.form.hora = ''
          }
        }
      }
    },

    onClickInterval(interval) {
      console.log('Intervalo seleccionado:', interval)
    },
    // eliminarEvento(date, index) {
    //   console.log('Fecha del evento a eliminar:', date, index)
    //   // Elimina el evento del arreglo
    //   // Si tienes también el arreglo original eventos2, actualízalo
    //   if (index >= 0){
    //     this.eventos2.splice(index, 1)
    //     this.events2Map[date].splice(index, 1)
    //   }  
    // },
    intervalFormat (interval) {
      // devuelve “00:00, 01:00, … 23:00” incluso si cruza medianoche
      const [h, m] = interval.time.split(':').map(Number)
      return `${(h % 24).toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`
    },
    addMinutesLocal(fechaStr, minutosASumar) {
      const fecha = new Date(fechaStr.toString())
      let fechaNueva = fecha.setMinutes(fecha.getMinutes() + minutosASumar)
      let fechaFinal = new Date(fechaNueva).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' + new Date(fechaNueva).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      return fechaFinal
    },
    convertirFecha(fechaStr) {
      // Crear un objeto Date a partir de la cadena en formato "dd/MM/YYYY hh:mm p.m"
      const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}) (a\.m\.|p\.m\.)/;
      const matches = fechaStr.match(regex);
      
      if (!matches) {
        throw new Error("El formato de la fecha no es válido.");
      }

      const [_, dia, mes, año, horas, minutos, merid] = matches;

      // Crear un objeto Date con la fecha y hora
      let date = new Date(`${año}-${mes}-${dia}T${horas}:${minutos}:00`);

      // Ajustar la hora según el valor "p.m." o "a.m."
      if (merid === 'p.m.' && date.getHours() < 12) {
        date.setHours(date.getHours() + 12); // Convertir a 24 horas si es "p.m."
      }
      if (merid === 'a.m.' && date.getHours() === 12) {
        date.setHours(0); // Convertir las 12 a.m. a 00:00
      }

      // Formatear la fecha de salida en "YYYY-MM-DD hh:mm"
      const añoFormateado = date.getFullYear();
      const mesFormateado = String(date.getMonth() + 1).padStart(2, '0');
      const diaFormateado = String(date.getDate()).padStart(2, '0');
      const horasFormateado = String(date.getHours()).padStart(2, '0');
      const minutosFormateado = String(date.getMinutes()).padStart(2, '0');

      return `${añoFormateado}-${mesFormateado}-${diaFormateado} ${horasFormateado}:${minutosFormateado}`;
    },
    randomColor () {
      const colors = ['blue', 'red', 'green', 'purple', 'indigo', 'orange']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    sumarMinutos(time, minutos) {
      const fecha = new Date(time)
      fecha.setMinutes(fecha.getMinutes() + minutos)
      console.log('Nueva Fecha:', fecha)
      return fecha.toISOString().slice(0, 10)
    },
    enviarInvitacion () {
      this.errores = {}
      this.loadingInvitacion = true

      if (this.enableAdvancedShipments) {
        this.enviarInvitacionAdvanced()
        return
      }

      // ---- FLUJO LEGACY (sin cambios) ----
      const baseData = {
        empresa: this.id_empresa_empresarial,
        administrador: this.admin === undefined ? '' : this.admin.email,
        loading_area: this.form.areas,
        client: this.form.client,
        window_date: this.form.fechaVentana,
        window_time: this.form.hora,
        transport_type: this.form.typeTransport,
        observations: this.form.notas,
        tipo_movimiento: this.tipoMovimiento
      }

      if (this.enableAdvancedShipments && this.isInternal) {
        baseData.is_internal = true
        baseData.empleado_id = this.empleadoId
        if (this.vehicleId) {
          baseData.vehicle_id = this.vehicleId
        }
      } else {
        baseData.is_internal = false
      }

      let dataToSend = {}
      if (this.documentos.length > 0) {
        dataToSend = {
          empresa: this.id_empresa_empresarial,
          administrador: this.admin === undefined ? '' : this.admin.email,
          loading_area: this.form.areas,
          client_ids: this.form.client_ids,
          window_date: this.form.fechaVentana,
          window_time: this.form.hora,
          transport_type: this.form.typeTransport,
          observations: this.form.notas,
          documentation: this.documentos
        }
      } else {
        dataToSend = {
          empresa: this.id_empresa_empresarial,
          administrador: this.admin === undefined ? '' : this.admin.email,
          loading_area: this.form.areas,
          client_ids: this.form.client_ids,
          window_date: this.form.fechaVentana,
          window_time: this.form.hora,
          transport_type: this.form.typeTransport,
          observations: this.form.notas
        }
      }

      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/createShipmentReferredInv/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: dataToSend
      }

      axios(config)
        .then(ok => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          if (error.response && error.response.status === 400 && typeof error.response.data === 'object') {
            this.errores = error.response.data
          }
          if (error.response && error.response.status === 401) {
            console.log('No ha pagado el Servicio')
          }
        })
        .finally(() => {
          this.loadingInvitacion = false
        })

      console.log('Invitación enviada:', this.form)
    },
    // Flujo Advanced: EMBARQUE/RECEPCION, Interno/Externo (ver createShipmentReferredInv)
    enviarInvitacionAdvanced () {
      const fail = (field, message) => {
        this.errores[field] = [message]
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', message)
        this.loadingInvitacion = false
      }

      if (!this.form.areas) return fail('loading_area', 'Debe seleccionar un área de carga')
      if (!this.form.fechaVentana) return fail('window_date', 'Debe seleccionar una fecha')
      if (!this.form.hora) return fail('window_time', 'Debe seleccionar una hora')
      if (!this.form.typeTransport) return fail('transport_type', 'Debe seleccionar un tipo de transporte')

      if (this.tipoMovimiento === 'EMBARQUE') {
        if (!this.form.client_ids || this.form.client_ids.length === 0) {
          return fail('client_ids', 'Debe seleccionar al menos un cliente destino')
        }
      } else {
        const destino = (this.destinationCompanyName || '').trim()
        if (!destino) return fail('destination_company_name', 'No se pudo determinar la empresa del usuario para la planta destino')
        if (destino.length > 200) return fail('destination_company_name', 'El nombre de la empresa (planta destino) no debe exceder 200 caracteres')
      }

      const dataToSend = {
        tipo_movimiento: this.tipoMovimiento,
        loading_area: this.form.areas,
        window_date: this.form.fechaVentana,
        window_time: this.form.hora,
        transport_type: this.form.typeTransport,
        observations: this.form.notas,
        is_internal: this.isInternal
      }

      if (this.tipoMovimiento === 'EMBARQUE') {
        dataToSend.client_ids = this.form.client_ids
      } else {
        dataToSend.destination_company_name = this.destinationCompanyName.trim()
      }

      // Empresa/Administrador: mismo catálogo de transportista para Interno y Externo
      const hasCarrier = this.selectedCarrier && (this.selectedCarrier.id || (typeof this.selectedCarrier === 'string' && this.selectedCarrier.trim() !== ''))
      if (!hasCarrier) {
        return fail('empresa', 'Debe seleccionar un transportista del catálogo o ingresar uno nuevo')
      }
      if (!this.adminEmailInvitacion) {
        return fail('administrador', 'Debe ingresar el email del administrador')
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.adminEmailInvitacion)) {
        return fail('administrador', 'Ingrese un email válido')
      }

      const empresaNombre = typeof this.selectedCarrier === 'string'
        ? this.selectedCarrier
        : (this.selectedCarrier && this.selectedCarrier.name) || (this.selectedCarrier && this.selectedCarrier.company_name) || ''

      dataToSend.empresa = null
      dataToSend.empresa_name = empresaNombre
      dataToSend.administrador = this.adminEmailInvitacion
      if (this.selectedCarrier && this.selectedCarrier.id) {
        dataToSend.carrier_id = this.selectedCarrier.id
      }

      if (this.isInternal) {
        if (!this.empleadoId) return fail('empleado_id', 'Debe seleccionar un chofer/receptor para la asignación interna')
        if (this.tipoMovimiento === 'EMBARQUE' && !this.vehicleId) {
          return fail('vehicle_id', 'Debe seleccionar un vehículo para embarque interno')
        }

        dataToSend.empleado_id = this.empleadoId
        if (this.tipoMovimiento === 'EMBARQUE') {
          dataToSend.vehicle_id = this.vehicleId
        }
      }

      if (this.documentos.length > 0) {
        dataToSend.documentation = this.documentos
      }

      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/createShipmentReferredInv/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: dataToSend
      }

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Invitación creada exitosamente. El email ha sido enviado al administrador.')
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          console.error('Error:', error)
          if (error.response && error.response.status === 400 && typeof error.response.data === 'object') {
            this.errores = error.response.data
          }
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Error al crear la invitación')
        })
        .finally(() => {
          this.loadingInvitacion = false
        })
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_activate_false')
      this.clean_fields()
    },
    clear2: function () {
      this.errores = []
      this.$store.commit('snackbar_activate_false')
    },
    clean_fields(){
      const date = new Date()
      this.currentDate = date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0')
      this.form = {
        opciones: [],
        fecha: this.currentDate,
        fechaVentana: this.currentDate,
        fechaVentanaRecurrente: '',
        hora: '',
        dias: [],
        documentos: [],
        personas: [],
        areas: null,
        client_ids: [],
        address: '',
        loading_time_minutes: '',
        typeTransport: '',
        notas: '',
        empresa: '',
        administrador: ''
      }
      this.documentos = []
      // Campos Invitacion Empresarial
      this.administradores = []
      this.id_empresa_empresarial = ''
      this.admin = {}
      this.adminEmailInvitacion = ''
      this.bandSinAdministrador = false
      // Campos Advanced Shipments - NO resetear enableAdvancedShipments, es sincronizado con getProfile
      this.tipoMovimiento = 'EMBARQUE'
      this.isInternal = false
      this.empleadoId = ''
      this.vehicleId = ''
      this.vehicles = []
      this.availableDrivers = []
      this.selectedCarrier = null
      this.carrierSearchText = ''
      this.empresaInvitarNombre = ''
    },
    rellenaCamposDireccionDuracionCarga (){
      // Usar el primer cliente seleccionado para obtener dirección y duración
      const primerClienteId = this.form.client_ids && this.form.client_ids.length > 0 ? this.form.client_ids[0] : null
      const clienteSeleccionado = primerClienteId ? this.clients.find(c => c.id === primerClienteId) : null
      if (clienteSeleccionado) {
        this.form.address = clienteSeleccionado.address
        this.form.loading_time_minutes = clienteSeleccionado.loading_time_minutes
        this.llenaCalendario(clienteSeleccionado)
      } else {
        this.form.address = ''
        this.form.loading_time_minutes = ''
      }
    },
    llenaCalendario (client) {
      console.log('Cliente seleccionado para el calendario:', client)
      this.timeInterval = parseInt(client.loading_time_minutes, 10)
      this.numberSlots = 48
    },
    rellenaCamposRecepcion (){
      // RECEPCION no tiene cliente registrado: usa una duración fija por defecto
      if (this.destinationCompanyName && this.destinationCompanyName.trim() !== '') {
        const duracionFija = this.estimatedDurationHours * 60
        this.form.loading_time_minutes = duracionFija
        this.llenaCalendario({ loading_time_minutes: duracionFija })
      } else {
        this.form.loading_time_minutes = ''
      }
    },
    enableCalendar () {
      this.disabledCalendar = this.disabledCalendar2 = this.disabledCalendar3 = this.disabledCalendar4 = this.disabledCalendar5 = this.disabledCalendar6 = true
      const areaSeleccionada = this.chargeAreas.find(c => c.id === this.form.areas)
      console.log('Área seleccionada:', areaSeleccionada)
      if (areaSeleccionada) {
        if (areaSeleccionada.name === 'Andén No. 1') {
          this.disabledCalendar = false
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 1')
        }
        if (areaSeleccionada.name === 'Andén No. 2') {
          this.disabledCalendar = true
          this.disabledCalendar2 = false
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 2')
        }
        if (areaSeleccionada.name === 'Andén No. 3') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = false
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 3')
        }
        if (areaSeleccionada.name === 'Rampa n°1') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = false
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Rampa n°1')
        }
        if (areaSeleccionada.name === 'Área de carga de atados n°1 (Puerta 4)') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = false
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Área de carga de atados n°1 (Puerta 4)')
        }
        if (areaSeleccionada.name === 'Área de carga de atados n°2 (Caseta 2-Nave 5)') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = false
          console.log('Calendario habilitado para Área de carga de atados n°2 (Caseta 2-Nave 5)')
        }
      }
    },
    generarPDF () {
      const doc = new JSPDF()
      doc.setFontSize(16)
      doc.text('Invitación', 20, 20)
      doc.setFontSize(12)

      doc.text(`📅 Fecha: ${this.form.fecha || 'No definida'}`, 20, 40)
      doc.text(`⏰ Hora: ${this.form.hora || 'No definida'}`, 20, 50)
      doc.text(`🗓️ Días: ${this.form.dias.join(', ') || 'No definidos'}`, 20, 60)
      doc.text(`👥 Invitados: ${this.form.personas.join(', ') || 'Ninguno'}`, 20, 70)
      doc.text('📝 Notas:', 20, 80)

      const lineasNotas = doc.splitTextToSize(this.form.notas || 'Sin notas', 170)
      doc.text(lineasNotas, 20, 90)

      doc.save('invitacion.pdf')
    },
    addShareEmail(val) {
        let emailToAdd = typeof val === 'string' ? val : this.shareEmailInput || this.shareEmailSearchText;
        
        if (typeof emailToAdd === 'object' && emailToAdd !== null && emailToAdd.id_usuario) {
            emailToAdd = emailToAdd.id_usuario.email;
        }

        if (emailToAdd && typeof emailToAdd === 'string' && this.isValidEmail(emailToAdd.trim())) {
            let emailClean = emailToAdd.trim();
            if (!this.shareEmails.includes(emailClean)) {
                this.shareEmails.push(emailClean);
            }
            this.$nextTick(() => {
                this.shareEmailInput = null;
                this.shareEmailSearchText = null;
            });
        } else if (emailToAdd && typeof emailToAdd === 'string' && emailToAdd.trim().length > 0) {
            this.$store.commit('snackbar_change_color', 'error');
            this.$store.commit('snackbar_activate_true');
            this.$store.commit('snackbar_change_message', 'Correo inválido');
            setTimeout(this.clear2, 3000);
        }
    },
    removeShareEmail(index) {
        this.shareEmails.splice(index, 1);
    },
    isValidEmail(email) {
        return /.+@.+\..+/.test(email);
    },
    formatDate (dateStr) {
        if (!dateStr) return '';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return dateStr;
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },
    formatDateTime (date) {
      const d = new Date(date);
      const day   = String(d.getDate()).padStart(2,'0');
      const month = String(d.getMonth()+1).padStart(2,'0');
      const year  = d.getFullYear();
      const hours = String(d.getHours()).padStart(2,'0');
      const mins  = String(d.getMinutes()).padStart(2,'0');
      return `${day}/${month}/${year} ${hours}:${mins}`;
    },

    async generateAndShareProgram() {
      if (this.shareEmails.length === 0) {
        this.$store.commit('snackbar_change_color', 'error');
        this.$store.commit('snackbar_activate_true');
        this.$store.commit('snackbar_change_message', 'Agrega al menos un correo');
        setTimeout(this.clear2, 3000);
        return;
      }
      this.loadingShareProgram = true;

      try {
        // Collect all scheduled events across all calendars for the specific date
        // and ignore new unasigned slots
        let scheduledEvents = [];
        for (let i = 0; i < this.calendars.length; i++) {
          if (this.calendars[i].events && this.calendars[i].events.length > 0) {
            this.calendars[i].events.forEach(evt => {
              if (evt.date === this.form.fechaVentana && !evt.new) {
                scheduledEvents.push({
                   ...evt,
                   loadingAreaName: this.calendars[i].name
                });
              }
            });
          }
        }

        if (!this.mostrarCancelados) {
          scheduledEvents = scheduledEvents.filter(evt => {
            const title = (evt.title || '').toUpperCase();
            return title !== 'CANCELADA';
          });
        }

        // Sort events by time
        scheduledEvents.sort((a, b) => a.time.localeCompare(b.time));

        // Generate PDF
        const doc = new JSPDF();
        doc.setFontSize(16);
        // console.log('fecha :', this.form.fechaVentana)
        doc.text(`Programa de Embarques: ${this.formatDate(this.form.fechaVentana)}`, 14, 20);
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Generado el: ${this.formatDateTime(new Date())}`, 14, 28);
          
        const tableColumn = ["Hora", "Andén/Área", "Planta Destino", "Linea transportista", "Transporte", "Estado", "Duración"];
        const tableRows = [];

        scheduledEvents.forEach(evt => {
          const carrierLine = evt.invited_company ||
            'N/A';

          const rowData = [
            evt.time,
            evt.loadingAreaName || 'N/A',
            evt.client_name || 'N/A',
            carrierLine,
            evt.transport_type_name || 'N/A',
            evt.title || 'N/A',
            `${evt.duration || evt.loading_time_minutes} min`
          ];
          tableRows.push(rowData);
        });

        if (tableRows.length === 0) {
           tableRows.push([{ content: 'No hay embarques programados para esta fecha.', colSpan: 7, styles: { halign: 'center' } }]);
        }

        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 40,
          theme: 'grid',
          styles: { fontSize: 8 },
          headStyles: { fillColor: [25, 118, 210] },
          columnStyles: {
            0: { cellWidth: 15 }, // Hora
            1: { cellWidth: 32 }, // Andén/Área
            2: { cellWidth: 'auto' }, // Planta Destino
            3: { cellWidth: 32 }, // Linea del transportista
            4: { cellWidth: 30 }, // Transporte
            5: { cellWidth: 25 }, // Estado
            6: { cellWidth: 18 }  // Duración
          }
        });

        const pageHeight = doc.internal.pageSize.getHeight();
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text('Powered By Intrare', pageWidth / 2, pageHeight - 10, { align: 'center' });

        // Convert the PDF to a Blob
        const pdfBlob = doc.output('blob');
        
        const formData = new FormData();
        this.shareEmails.forEach(email => {
          formData.append('recipient_emails', email);
        });
        formData.append('pdf', pdfBlob, `programa_embarques_${this.form.fechaVentana}.pdf`);
        const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/send-report/',
          headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': 'Token ' + store.getters.getToken
          },
          data: formData
        };

        axios(config)
          .then(response => {
              this.$store.commit('snackbar_change_color', 'success');
              this.$store.commit('snackbar_activate_true');
              this.$store.commit('snackbar_change_message', 'Programa de embarques compartido correctamente.');
              setTimeout(this.clear2, 3000);
              this.dialogShareProgram = false;
              this.shareEmails = [];
          })
          .catch(error => {
              console.error(error);
              this.$store.commit('snackbar_change_color', 'error');
              this.$store.commit('snackbar_activate_true');
              this.$store.commit('snackbar_change_message', 'Error al compartir el programa de embarques.');
              
              doc.save(`programa_embarques_${this.form.fechaVentana}.pdf`);
              this.$store.commit('snackbar_change_color', 'success');
              this.$store.commit('snackbar_change_message', 'Reporte descargado localmente como respaldo.');
              setTimeout(this.clear2, 3000);
              this.dialogShareProgram = false;
          })
          .finally(() => {
              this.loadingShareProgram = false;
          });
      } catch(err) {
        console.error(err);
        this.loadingShareProgram = false;
        this.$store.commit('snackbar_change_color', 'error');
        this.$store.commit('snackbar_activate_true');
        this.$store.commit('snackbar_change_message', 'Error al generar el PDF del programa.');
        setTimeout(this.clear2, 3000);
      }
    },
    getStatusClass(event) {
      if (!event.title) return 'status-programada';
      const status = event.title.toUpperCase();
      if (status.includes('PROGRAMADA')) return 'status-programada';
      if (status.includes('CONFIRMADA')) return 'status-confirmada';
      if (status.includes('EN SITIO')) return 'status-en-sitio';
      if (status.includes('EN PROCESO')) return 'status-en-proceso';
      if (status.includes('LIBERADA')) return 'status-liberada';
      if (status.includes('COMPLETADA')) return 'status-completada';
      if (status.includes('CANCELADA')) return 'status-cancelada';
      if (status.includes('SELECCIONADO')) return 'status-seleccionado';
      return 'status-programada';
    },
    getStatusIcon(event) {
      if (!event.title) return 'schedule';
      const status = event.title.toUpperCase();
      if (status.includes('PROGRAMADA')) return 'info';
      if (status.includes('CONFIRMADA')) return 'verified_user';
      if (status.includes('EN SITIO')) return 'local_shipping';
      if (status.includes('EN PROCESO')) return 'autorenew';
      if (status.includes('LIBERADA')) return 'exit_to_app';
      if (status.includes('COMPLETADA')) return 'check_circle';
      if (status.includes('CANCELADA')) return 'block';
      if (status.includes('SELECCIONADO')) return 'touch_app';
      return 'schedule';
    },
    parseTime(timeStr) {
      if (!timeStr) return 0
      const [h, m] = timeStr.split(':').map(Number)
      return h * 60 + m
    },
    getNextDay(dateStr) {
      const date = new Date(dateStr + 'T12:00:00')
      date.setDate(date.getDate() + 1)
      return date.toISOString().substr(0, 10)
    },
    formatDisplayTime(timeStr) {
      if (!timeStr) return '00:00'
      const parts = timeStr.split(':')
      const h = parseInt(parts[0]) % 24
      const m = parts[1] || '00'
      return `${h.toString().padStart(2, '0')}:${m}`
    },
    saveShipmentTimeWindow() {
      const config = {
        method: 'patch',
        url: 'https://empresa-service.intrare.app/empresas/shipments_time_window',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          shipments_time_window: `${this.horaInicioCalendario}-${this.horaFinCalendario}`
        }
      };
      axios(config)
        .then(response => {
          console.log('Time window saved:', response.data);
          this.$store.dispatch(USER_REQUEST).catch(err => console.log(err))
        })
        .catch(error => {
          console.error('Error saving time window:', error);
        });
    }
  }
}
</script>
<style scoped>
  .border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
  .border-right {
    border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
  .border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
  .pointer {
    cursor: pointer;
  }

  .date-display {
    transition: background-color 0.3s;
  }
  .date-display:hover {
    background-color: var(--v-primary-lighten4) !important;
  }

  .legend-box {
    width: 14px;
    height: 14px;
    border-radius: 3px;
  }

  .calendar-container-wrapper {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
  }

  .calendar-grid {
    min-width: 800px; /* Asegura que las columnas no se colapsen demasiado */
    display: flex;
    flex-wrap: nowrap;
  }

  .calendar-column {
    min-width: 150px;
    flex: 1 0 0%;
  }

  .calendar-header-title {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: #f8faff;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .custom-calendar-style {
    background-color: white !important;
  }

  .interval-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  }

  .my-event {
    overflow: hidden;
    border-radius: 6px;
    font-size: 11px;
    padding: 4px 6px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
    z-index: 10;
  }

  .my-event:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    z-index: 11;
  }

  .event-content {
    display: flex;
    align-items: center;
    width: 100%;
    color: white;
    font-weight: 600;
  }

  .event-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .status-programada {
    background: linear-gradient(135deg, #1976D2 0%, #64B5F6 100%) !important;
    border: none;
  }

  .status-confirmada {
    background: linear-gradient(135deg, #0097A7 0%, #4DD0E1 100%) !important;
    border: none;
  }

  .status-en-sitio {
    background: linear-gradient(135deg, #FFA000 0%, #FFD54F 100%) !important;
    border: none;
  }

  .status-en-proceso {
    background: linear-gradient(135deg, #F57C00 0%, #FFB74D 100%) !important;
    border: none;
    animation: pulse-active 2s infinite;
  }

  .status-liberada {
    background: linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%) !important;
    border: none;
  }

  .status-completada {
    background: linear-gradient(135deg, #43A047 0%, #81C784 100%) !important;
    border: none;
  }

  .status-cancelada {
    background: linear-gradient(135deg, rgba(211, 47, 47, 0.4) 0%, rgba(239, 83, 80, 0.4) 100%) !important;
    border: 1px dashed rgba(211, 47, 47, 0.5) !important;
    z-index: 5 !important;
    box-shadow: none !important;
  }

  .status-cancelada .event-content {
    color: #b71c1c !important;
  }

  .status-cancelada .v-icon {
    color: #b71c1c !important;
  }

  .status-seleccionado {
    background: linear-gradient(135deg, #757575 0%, #9E9E9E 100%) !important;
    border: none;
  }

  @keyframes pulse-active {
    0% {
      box-shadow: 0 0 0 0 rgba(245, 124, 0, 0.4);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(245, 124, 0, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(245, 124, 0, 0);
    }
  }

  .with-time {
    position: absolute;
    left: 4px;
    right: 4px;
  }

  /* Custom scrollbar */
  .calendar-container-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .calendar-container-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .calendar-container-wrapper::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
  .calendar-container-wrapper::-webkit-scrollbar-thumb:hover {
    background: #bbb;
  }

  /* Ocultar lineas de tiempo internas que no necesitamos si usamos intervalos personalizados */
  .theme--light.v-calendar-daily {
    border: none !important;
  }
</style>